import { AbstractBlock } from '../AbstractBlock';
import { ColorSettings } from '../setting/ColorSettings';
import { ShapeSettings } from '../setting/ShapeSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { BlockType } from '../../@types/BlockType';
import { BlockTypeConsts } from '../setting/BlockTypeConsts';
import { block_translation } from '../../lang/BlockTranslation';
const t = block_translation;
export class ARHiroAttribute extends AbstractBlock {
  constructor() {
    super(BlockTypeConsts.AR_HIRO_ATTRIBUTE, t.to('Hiroマーカー', 'hiro_marker'));
  }
  defineBlock(block: BlockType): void {
    ShapeSettings.setAttributeShape(block);
    ColorSettings.setARColor(block);

    ShapeSettings.setTitleField(block, this.title);
    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string[] {
    const attribute = CodeSetting.getSubAttributeCode(block);
    const str = CodeSetting.buildAttribute([['preset', 'hiro']], attribute);
    return [str];
  }
}
